<template>
  <div>
    <banners-module />
    <div class="border-bottom">
      <header>
        <nav
          class="navbar navbar-default navbar-fixed-top navbar-front nav-project-sell"
        >
          <div class="container">
            <div class="content-element">
              <a
                :href="'tel:' + phoneCompactPrefix"
                class="telephone d-none d-xl-block"
                @click="eventTracking('call', 'clics_module', 'header')"
              >
                <img
                  :src="getPict('phone', 'svg', 'global')"
                  :alt="phoneNumber"
                />
                {{ phoneNumber }}
              </a>
              <a class="logo" href="/" :title="title">
                <img
                  v-if="subdomain"
                  :src="getPict(`logo-${subdomain}`, 'png', 'logos')"
                  :height="subdomain ? '22px' : '40px'"
                  :class="`subdomain-logo FunnelHeader__logo d-sm-none d-none d-md-block logo-${subdomain}`"
                  :alt="title"
                />
                <img
                  v-else
                  :src="getPict('logo-carizy-by-cofidis', 'svg', 'logos')"
                  :height="subdomain ? '22px' : '40px'"
                  :class="`subdomain-logo FunnelHeader__logo d-sm-none d-none d-md-block logo-${subdomain}`"
                  :alt="title"
                />
              </a>
              <call-back-module :type="type" />
            </div>
          </div>
        </nav>
      </header>
    </div>
  </div>
</template>

<script>
import CallBackModule from "../../../components/modules/modals/CallbackModule";
import UtilMixin from "../../../mixins/UtilMixin";
import BannersModule from "../../../components/modules/banners/bannersModule.vue";

export default {
  name: "HeaderFunnelModule",
  components: { BannersModule, CallBackModule },
  mixins: [UtilMixin],
  props: {
    type: {
      type: [Number, String],
      default: () => 1,
    },
  },
  data: () => ({
    subdomain: null,
    phoneNumber: null,
    title: null,
    phoneCompactPrefix: null,
    cdn: process.env.VUE_APP_CDN,
  }),
  mounted() {
    this.subdomain = this.getPartenaire().subdomain;
    this.phoneNumber = this.getPartenaire().phoneNumber;
    this.phoneCompactPrefix = this.getPartenaire().phoneCompactPrefix;
    this.title = this.getPartenaire().title;
    this.route = this.getPartenaire().route;
  },
};
</script>

<style lang="scss">
@import "../../../assets/sass/modules/headerFunnelModule";
</style>
